import { useI18N } from "@sundae/react-hooks";
import { ExternalLink, Image, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import { Trans } from "react-i18next";
import { PersistentActions, useProfileAppContext } from "../../stores";
import Motion from "../Motion/Motion";
import { externalRoutes } from "../../pages/routes";

const HotjarFirstVisitDialog = () => {
  const {
    dispatch,
    state: { hotjarEnabled },
  } = useProfileAppContext();
  const { t } = useI18N("first-visits");

  const handleHotJarOptIn = () => {
    PersistentActions.setHotjarEnabled(!hotjarEnabled, dispatch);
    location.reload();
  };

  return (
    <Motion className="grid place-items-center gap-4 text-center">
      <Image
        className={cx("pointer-events-none w-56")}
        height={400}
        src="/static/images/dudes/wally_zeus_400x400.png"
        width={400}
      />

      <Text tag="h2" size="2xl" weight="bold">
        {t("hotjar.title")}
      </Text>
      <Text tag="p">
        <Trans i18nKey="hotjar.disclaimer" ns="first-visits">
          We use the provider{" "}
          <ExternalLink arrow="top-right" variant="primary" href={externalRoutes.hotjar}>
            Hotjar
          </ExternalLink>{" "}
          to record user sessions. This service is only activated on the preview environment by
          default and can be deactivated at any time via the profile settings. No sensitive user
          data is passed on to Hotjar or similar - your data is treated anonymously and
          confidentially at all times.
        </Trans>
      </Text>
      <Text tag="div" size="xs" variant="silent" className="grid place-items-center">
        {hotjarEnabled ? (
          <Trans i18nKey="hotjar.optout" ns="first-visits">
            If you don't want your user session to be tracked, feel free to opt out right away:
            <Text
              tag="span"
              size="xs"
              className="cursor-pointer"
              role="button"
              variant="primary"
              onClick={handleHotJarOptIn}
            >
              Disable Hotjar tracking and reload page
            </Text>
          </Trans>
        ) : (
          <Trans i18nKey="hotjar.optin" ns="first-visits">
            If you want your user session to be tracked, feel free to opt in right away:
            <Text
              tag="span"
              size="xs"
              className="cursor-pointer"
              role="button"
              variant="primary"
              onClick={handleHotJarOptIn}
            >
              Enable Hotjar tracking and reload page
            </Text>
          </Trans>
        )}
      </Text>
    </Motion>
  );
};

export default HotjarFirstVisitDialog;
